import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const divisionModURL = "api/v1/products-app/division";
//obtaining the paginated data
export const getDivision = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${divisionModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllDivision = () => axiosInstance.get(`${divisionModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageDivision = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${divisionModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createDivision = (body) => axiosInstance.post(`${divisionModURL}/create`, body);
//updating function
export const updateDivision = (id, body) => axiosInstance.patch(`${divisionModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${divisionModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`);

// checking the redundant data
export const checkRedundantDataDivisionName = (e, cancelToken) =>
  axiosInstance.get(`${divisionModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
